var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import Theme from '../../Theme';
import { Button, View } from '../../elements';
import CountUp from '../../components/CountUp';
import { KeyTouchable } from './KeyTouchable';
import Text from '../../elements/Text';
import { priceWithTax } from '../Utils/Util';
import { observer } from 'mobx-react';
import theme from '../../Theme';
import { toRound } from '../../helpers/Format';
import { T } from '../../helpers/i18n';
let SaleC = class SaleC extends Component {
    constructor() {
        super(...arguments);
        this.inputPassenger = null;
        this.handleInput = () => {
            if (!!!this.inputPassenger)
                return;
            if (this.props.handleInputPassenger) {
                this.props.handleInputPassenger(this.inputPassenger, this.props.item);
            }
        };
    }
    render() {
        var _a;
        const { item, index, lista, height, paddingBloque, busy, moneyName, quantity, handleKeyMinus, handleKeyPlus, lineTotal, itemExtra, includedExtras, categoryId } = this.props;
        // console.log('SaleC - item: ', item)
        // console.log('SaleC - itemExtra: ', itemExtra)
        if ((item && item.stretchPrice.price >= 0) || itemExtra) {
            const name = item
                ? item.stretchPrice.passengerCategory.name
                : itemExtra.name;
            const price = item
                ? priceWithTax(item.stretchPrice.price, item.stretchPrice.tax.value, item.stretchPrice.passengerCategory)
                : priceWithTax(itemExtra.price.price, itemExtra.price.tax.value, null);
            const priceNet = item &&
                item.stretchPrice.priceNet &&
                priceWithTax(item.stretchPrice.priceNet, item.stretchPrice.tax.value, item.stretchPrice.passengerCategory);
            return (React.createElement(View, { flex: true, style: {
                    minHeight: '70px',
                }, key: 1 },
                React.createElement(View, { flex: true, center: true, row: true },
                    React.createElement(View, { flex: 5, style: {
                            /*flex: 5,*/
                            paddingLeft: 10,
                            /*display: 'flex',*/
                            marginBottom: 0,
                            marginTop: 0,
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            backgroundColor: ((_a = item === null || item === void 0 ? void 0 : item.stretchPrice) === null || _a === void 0 ? void 0 : _a.affiliate) ? '#fafafa'
                                : undefined,
                        } },
                        React.createElement("p", { style: {
                                marginBottom: 0,
                                marginTop: 0,
                                fontWeight: 'bold',
                                fontSize: 16,
                            } }, name),
                        React.createElement("p", { style: { marginBottom: 0, marginTop: 0, paddingLeft: 10 } },
                            ' ',
                            `${toRound(price)} ${moneyName}`),
                        item && item.stretchPrice.priceNet && (React.createElement("p", { style: {
                                marginBottom: 0,
                                marginTop: 0,
                                paddingLeft: 10,
                                color: '#dbdbdb',
                            } },
                            ' ',
                            `${toRound(priceNet)} ${moneyName}`))),
                    item && React.createElement("p", { style: {
                            flex: 1.5,
                            fontSize: 'smaller',
                            color: quantity(item) > 0 ? item.stretchPrice.passengerCategory.minToReserve <= quantity(item) ? 'green' : 'red' : theme.color.secondary
                        } }, item.stretchPrice.passengerCategory.minToReserve > 0 ? `${T('minToReserve')} ${item.stretchPrice.passengerCategory.minToReserve}` : ''),
                    React.createElement("div", { style: {
                            flex: 2,
                            margin: 0,
                            textAlign: 'center',
                            color: Theme.color.primary,
                        } },
                        React.createElement(CountUp, { money: true, moneyData: moneyName, duration: 300, primary: item ? item.stretchPrice.printPrice : true, to: priceWithTax(lineTotal(item !== null && item !== void 0 ? item : itemExtra), item
                                ? item.stretchPrice.tax.value
                                : itemExtra.price.tax.value, item ? item.stretchPrice.passengerCategory : null) // -
                         }, 0)),
                    React.createElement(Button, { onClick: () => handleKeyMinus(item !== null && item !== void 0 ? item : itemExtra), style: {
                            width: '50px',
                            height: '50px',
                            borderRadius: 5,
                            border: `2px solid ${Theme.color.primary}`,
                        } }, '-'),
                    React.createElement("p", { style: { margin: 0, textAlign: 'center', flex: 1 } }, quantity(item !== null && item !== void 0 ? item : itemExtra)),
                    React.createElement(Button, { onClick: () => handleKeyPlus(item !== null && item !== void 0 ? item : itemExtra), style: {
                            width: '50px',
                            height: '50px',
                            borderRadius: 5,
                            border: `2px solid ${Theme.color.primary}`,
                            marginRight: 10,
                            textSize: 20,
                        } }, '+')),
                (() => {
                    // Filtramos SOLO los extras asignados explícitamente a esta categoría (excluimos los globales null)
                    const categorySpecificExtras = (includedExtras === null || includedExtras === void 0 ? void 0 : includedExtras.filter(includedExtra => includedExtra.passengerCategory_id === categoryId)) || [];
                    if (categorySpecificExtras.length === 0)
                        return null;
                    const currentQty = quantity(item) || 0;
                    return (React.createElement("div", { className: "col-12 mt-1 pt-1 mb-1" },
                        React.createElement("span", { className: "font-weight-bold d-block", style: { fontSize: '11px', color: theme.color.secondary } }, "Incluye:"),
                        React.createElement("div", { className: "d-flex flex-wrap gap-1" }, categorySpecificExtras.map((categorySpecificExtra, idx) => {
                            var _a;
                            const isPerPassenger = categorySpecificExtra.allocationRule === 'per_passenger';
                            // Cálculo dinámico para esta tarjeta específica
                            const totalExtraQty = isPerPassenger
                                ? categorySpecificExtra.quantityMultiplier * currentQty
                                : (currentQty > 0 ? categorySpecificExtra.quantityMultiplier : 0);
                            return (React.createElement("span", { key: idx, className: 'badge border mr-1 mb-1 px-2 py-1 text-white', style: { fontSize: '10px', backgroundColor: Theme.color.secondary } },
                                ((_a = categorySpecificExtra.extra) === null || _a === void 0 ? void 0 : _a.name) || 'Extra',
                                React.createElement("strong", { className: 'ml-1 font-weight-bold text-white' },
                                    "(",
                                    totalExtraQty > 0 ? `x${totalExtraQty}` : (isPerPassenger ? '1x pax' : '1x reserva'),
                                    ")")));
                        }))));
                })(),
                index < lista.length - 1 && (React.createElement("div", { style: {
                        marginLeft: '10px',
                        marginRight: '10px',
                        height: 1,
                        background: theme.color.hairline,
                    } }, ''))));
            return (React.createElement(View, null,
                React.createElement(View, { flex: true, key: item ? item.stretchPrice.passengerCategory.id : itemExtra.price.id, 
                    /*row*/
                    style: {
                        height: height,
                        borderBottomWidth: (index !== lista.length - 1 && Theme.size.hairline) || 0,
                        borderBottomColor: Theme.color.hairline,
                        marginLeft: 0,
                        marginRight: 0,
                        alignItems: 'center',
                        flexDirection: 'row',
                        justifyContent: 'center',
                    } },
                    React.createElement(View, { style: {
                            flex: 7,
                            alignContent: 'center',
                            justifyContent: 'center',
                            alignItems: 'center',
                        } },
                        React.createElement(CountUp, { money: true, duration: 300, primary: item ? item.stretchPrice.printPrice : true, to: priceWithTax(lineTotal(item ? item : itemExtra), item
                                ? item.stretchPrice.tax.value
                                : itemExtra.price.tax.value, item ? item.stretchPrice.passengerCategory : null) // -
                         }, "0")),
                    React.createElement(KeyTouchable, { disabled: busy, onClick: handleKeyMinus(item ? item : itemExtra) },
                        React.createElement(Text, { big: true, center: true, style: textBorded }, "-")),
                    React.createElement(KeyTouchable, { disabled: busy, onClick: handleKeyPlus(item ? item : itemExtra) },
                        React.createElement(Text, { big: true, center: true, style: textBorded }, "+")))));
        }
        else {
            return null;
        }
    }
};
SaleC = __decorate([
    observer
], SaleC);
export default SaleC;
const bordedSize = 55;
const borderPadding = 5;
const textBorded = {
    /*flex: 1,*/
    height: bordedSize,
    width: bordedSize,
    borderColor: Theme.color.primary,
    borderWidth: 2,
    borderRadius: 5,
    fontWeight: 300,
    fontSize: 30,
    lineHeight: bordedSize - borderPadding,
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/components/SaleC.tsx
// module id = 115
// module chunks = 0